// FloorViewer postMessage schema & constants
// 集中管理 message 相關的字串與結構說明

export const FLOOR_VIEWER_SOURCE = 'floor-viewer';
export const FLOOR_VIEWER_HOST_SOURCE = 'floor-viewer-host';

export const FLOOR_VIEWER_MESSAGE_TYPES = Object.freeze({
  INITIALIZED: 'initialized',
  NAVIGATION: 'navigation',
  COMMAND: 'command',
});

export const FLOOR_VIEWER_COMMANDS = Object.freeze({
  NAVIGATE: 'navigate',
  SETTINGS: 'settings',
});

export const FLOOR_VIEWER_NAVIGATE_KINDS = Object.freeze({
  CHANGE_FLOOR: 'change-floor',
  GOTO_HOTSPOT: 'goto-hotspot',
  SET_VIEW: 'set-view',
  SYNC_FROM_URL: 'sync-from-url',
});

export const FLOOR_VIEWER_SETTINGS_KINDS = Object.freeze({
  CHANGE_LOCALE: 'change-locale',
});

/**
 * @typedef {Object} FloorViewerNavigationPayload
 * @property {string|null} buildingId
 * @property {number|null} floorIndex
 * @property {string|null} floorId
 * @property {string|null} viewState   // 'DOWN' | 'TOP' | 'FLOORPLAN'
 * @property {string|null} hotspotId
 * @property {boolean|null} isCameraMoving
 * @property {Object} query
 */

/**
 * @typedef {Object} FloorViewerInitializedPayload
 * @property {string|null} buildingId
 * @property {Object|null} building
 */

/**
 * @typedef {Object} FloorViewerOutboundMessage
 * @property {'floor-viewer'} source
 * @property {'initialized'|'navigation'} type
 * @property {FloorViewerInitializedPayload|FloorViewerNavigationPayload} payload
 */

/**
 * @typedef {Object} FloorViewerNavigateCommandPayload
 * @property {'change-floor'|'goto-hotspot'|'set-view'|'sync-from-url'} kind
 * @property {number} [floorIndex]
 * @property {string} [floorId]
 * @property {string} [hotspotId]
 * @property {string} [viewState]
 * @property {Object} [query]
 */

/**
 * @typedef {Object} FloorViewerSettingsCommandPayload
 * @property {'change-locale'} kind
 * @property {string} locale
 */

/**
 * @typedef {Object} FloorViewerInboundCommandMessage
 * @property {'floor-viewer'} target
 * @property {'command'} type
 * @property {'navigate'|'settings'} command
 * @property {FloorViewerNavigateCommandPayload|FloorViewerSettingsCommandPayload} payload
 */
